import { z } from "zod";

const phoneNumberRegex = /^\+?[1-9]\d{1,14}$/;

export const phoneNumberSchema = z
  .string()
  .transform((value) => value.replace(/[^\d+]/g, ""))
  .refine((value) => phoneNumberRegex.test(value), {
    message: "Invalid phone number format",
  });

/**
 * Normalizes a US phone number to North-American E.164 format (`+1XXXXXXXXXX`).
 * Strips spaces, dashes, parentheses, and an optional leading `1` or `+1`.
 * Throws if the input doesn't reduce to exactly 10 digits.
 */
export function formatPhoneNumber(phoneNumber: string): string {
  const validationResult = phoneNumberSchema.safeParse(phoneNumber);

  if (!validationResult.success) {
    throw new Error(validationResult.error.errors[0].message);
  }

  const cleanedNumber = phoneNumber.replace(/[^\d+]/g, "");
  const formattedNumber = cleanedNumber.startsWith("+1")
    ? cleanedNumber
    : `+1${cleanedNumber.startsWith("1") ? cleanedNumber.slice(1) : cleanedNumber}`;

  if (!/^\+1\d{10}$/.test(formattedNumber)) {
    throw new Error("Phone number must be in North American E.164 format (+1 followed by 10 digits)");
  }

  return formattedNumber;
}
